import React from 'react';
import styled from 'styled-components';

interface FilterChipProps {
    label: string;
    active?: boolean;
    onClick?: () => void;
}

const Chip = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 500;
    border: 1px solid #e0e0e0;
    cursor: pointer;
    font-family: inherit;
    background: #fff;
    color: #888;
    transition: all 0.1s;

    &:hover {
        background: #f5f5f5;
    }
`;

const ActiveDot = styled.span`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #111;
`;

export const FilterChip: React.FC<FilterChipProps> = ({ label, active, onClick }) => (
    <Chip type="button" onClick={onClick} style={active ? { color: '#333' } : undefined}>
        {active && <ActiveDot />}
        {label}
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" stroke="currentColor"
            strokeWidth="1.3" strokeLinecap="round">
            <path d="M2 3L4 5L6 3" />
        </svg>
    </Chip>
);
